var _ = require("underscore");
// values are ordered decending by digit specification lenght
// if DISCOVER with 622126-622925 found I will be taking over the 62 of UNIONPAY because _.find of underscore return first found
var values = [

	{
		code: "DISCOVER",
		digits: [60, "622126-622925", 64, 65]
	},
	{
		code: "MASTERCARD",
		digits: [50, 51, 52, 53, 54, 55, "2221-2720"]
	},
	{
		code: "DINERS",
		digits: [2014, 2149, 300, 305, 309, 36, 38, 39]
	},
	{
		code: "UNIONPAY",
		digits: [62]
	},
	{
		code: "AMEX",
		digits: [34, 37]
	},
	{
		code: "JCB",
		digits: [35]
	},
	{
		code: "VISA",
		digits: [4]
	}
];

function startBy(big, small) {
	return big.indexOf(small) === 0;
}
/**
 * Attempts to identify the provided card number.
 *
 * @param input The entered credit card number
 * @return Credit card code if a match is found, null if no match
 */
function identifyCode(input) {
	if (!input) {
		return null;
	}
	input = input.toString();

	var foundValue = _.find(values, function(value) {
		return _.find(value.digits, function(digit) {
			if (typeof digit === "number") {
				return startBy(input, digit);
			}
			var digitRange = digit.split("-");
			if (digitRange.length !== 2) {
				return false;
			}
			var maxNumberOfDigit = digitRange[1].toString().length;
			var slicedInput = parseInt(input.toString().substring(0, maxNumberOfDigit));

			return slicedInput >= digitRange[0] && slicedInput <= digitRange[1];
		});
	});

	return (foundValue && foundValue.code) ? foundValue.code : null;
}

module.exports = {
	identifyCode: identifyCode,
	values: values
};
